import React from 'react';
import { Row, Col, Label, Button } from "reactstrap";
import { observer, inject } from 'mobx-react';
import _ from 'lodash';
import moment from 'moment';
import NumberFormat from 'react-number-format';
import FormInput from '../../../comum/components/FormInput';
import FormInputNumber from '../../../comum/components/FormInputNumber';
import FormInputCurrency from '../../../comum/components/FormInputCurrency';
import FormInputCNPJCPF from '../../../comum/components/FormInputCNPJCPF';
import FormSelect from '../../../comum/components/FormSelect';
import FormDatePicker from '../../../comum/components/FormDatePicker'
import CardNotaFiscalContainersLivre from './CardNotaFiscalContainersLivre';
import CardNotaFiscalNCM from '../../containers-cadastrar/entrada-containers/components/CardNotaFiscalNCM';
import LoadingImage from "../../../comum/components/LoadingImage";
import CheckboxField from "../../../comum/components/CheckboxField";
import { quantidadeMinChar44 } from "../../../../utils/validadores";

@inject("store")
@observer
export default class NotaFiscalForm extends React.Component {
    constructor(props) {
        super(props);
        this.appStore = this.props.store.appStore;
        this.controller = this.props.controller;
        this.somenteLeitura = false;

        this.handleRemoverContainer = this.handleRemoverContainer.bind(this);
        this.handleClickBagagem = this.handleClickBagagem.bind(this);
        this.handleClickBitrem = this.handleClickBitrem.bind(this);
    }

    componentDidMount() {
        this.controller.carregarPaises();
        if (!this.props.editar && this.props.notaSelecionada) {
            this.controller.carregarNotaSelecionada(this.props.notaSelecionada, this.props.duplicar);
        }
        else {
            if (this.props.dadosNota.Nf != null && this.props.dadosNota.Nf.Status != "P") {
                this.somenteLeitura = true;
            }
        }
    }

    componentDidUpdate() {
        if (this.props.editar) {
            if (this.props.dadosNota.Nf != null && this.props.dadosNota.Nf.Status != "P") {
                this.somenteLeitura = true;
            }
        }
    }

    handleRemoverContainer = (index) => {
        this.controller.removerContainer(index);
    };

    handleMudaCnpjEmissor = (cnpj) => {
        this.controller.setCNPJEmissor('Nf.Cnpjs', cnpj);
    };

    handleMudaCnpjDestinatario = (cnpj) => {
        this.controller.setCNPJDestinatario('Nf.CnpjDest', cnpj);
    };

    listaNotaFiscal() {
        return <div>
            <Row className="area-form">
                {this.props.isRIG && <CheckboxField sm={12} md={3} noTitle={true}
                    text="Bagagem"
                    ativo={this.controller.flagAtivo}
                    onClick={(event) => this.handleClickBagagem(event)}
                    disabled={this.somenteLeitura}
                />}
                {this.props.isSSA && <CheckboxField sm={12} md={3} noTitle={true}
                    text="Bi-trem"
                    ativo={this.controller.flagAtivo}
                    onClick={(event) => this.handleClickBitrem(event)}
                    disabled={this.somenteLeitura}
                />}
            </Row>
            <Row className="area-form">
                {this.controller.atualizaBagagem &&
                    <FormInput titulo={this.props.isRIG && this.controller.flagAtivo ? "Número DUE" : "Nota"} sm={12} md={3}
                        bloqueado={this.somenteLeitura ? this.somenteLeitura : !!this.props.editar && this.props.isSSA}
                        objeto={this.props.dadosNota}
                        dado={`Nf.NumNotaTransp`}
                        limiteMaximo={30}
                        //alerta={ (this.props.salvo && !_.get(this.props.dadosNota, "Nf.NumNotaTransp")) ? "Campo obrigatório" : "" }
                        onChange={(event) => this.controller.setDadosNotaFiscal(`Nf.NumNotaTransp`, event.target.value)}
                    />}
                {this.controller.atualizaBagagem &&
                    <FormInput titulo="Série" sm={12} md={3}
                        //bloqueado={!!this.props.editar && this.props.isSSA}
                        objeto={this.props.dadosNota}
                        dado={`Nf.SerieNotaTransp`}
                        limiteMaximo={5}
                        //alerta={ (this.props.salvo && !this.controller.flagAtivo && !_.get(this.props.dadosNota, "Nf.SerieNotaTransp")) ? "Campo obrigatório" : "" }
                        onChange={(event) => this.controller.setDadosNotaFiscal(`Nf.SerieNotaTransp`, event.target.value)}
                        bloqueado={this.somenteLeitura ? this.somenteLeitura : (this.props.isRIG) ? this.controller.flagAtivo : false}
                    />
                }
                {this.controller.atualizaBagagem &&
                    <FormInputNumber titulo="Chave NFe" sm={12} md={3}
                        objeto={this.props.dadosNota}
                        dado={`Nf.ChaveNfe`}
                        limiteMaximo={44}
                        limiteMinimo={44}
                        validador={quantidadeMinChar44}
                        validacaoStore={this.controller.setValidacao}
                        onChange={event => this.controller.setDadosNotaFiscal(`Nf.ChaveNfe`, event.target.value)}
                        //alerta={ (this.props.salvo && !this.controller.flagAtivo && !_.get(this.props.dadosNota, "Nf.ChaveNfe")) ? "Campo obrigatório" : "" } 
                        bloqueado={this.somenteLeitura ? this.somenteLeitura : (this.props.isRIG) ? this.controller.flagAtivo : false}
                    />
                }
                {this.props.isSSA && this.controller.carregouNF &&
                    <FormInputCurrency titulo="Valor IPI" sm={12} md={3}
                        bloqueado={!!this.props.editar && this.props.isSSA}
                        objeto={this.props.dadosNota}
                        dado={`Nf.ValIpi`}
                        //alerta={ (this.props.salvo && !this.controller.flagAtivo && !_.has(this.props.dadosNota, "Nf.ValIpi")) ? "Campo obrigatório" : "" }
                        onChange={(event) => this.controller.setDadosNotaFiscal(`Nf.ValIpi`, event.target.value)}
                        bloqueado={this.somenteLeitura ? this.somenteLeitura : (this.props.isRIG) ? this.controller.flagAtivo : false}
                    />}
                {this.props.isSSA && this.controller.carregouNF &&
                    <FormInputCurrency titulo="Valor ICMS" sm={12} md={3}
                        //bloqueado={this.somenteLeitura ? this.somenteLeitura : !!this.props.editar && this.props.isSSA}
                        objeto={this.props.dadosNota}
                        dado={`Nf.ValIcms`}
                        //alerta={ (this.props.salvo && !this.controller.flagAtivo && !_.get(this.props.dadosNota, "Nf.ValIcms")) ? "Campo obrigatório" : "" }
                        onChange={(event) => this.controller.setDadosNotaFiscal(`Nf.ValIcms`, event.target.value)}
                        bloqueado={this.somenteLeitura ? this.somenteLeitura : (this.props.isRIG) ? this.controller.flagAtivo : false}
                    />}
                {this.controller.atualizaBagagem && this.controller.carregouNF &&
                    <FormInputNumber titulo="Quantidade Total" sm={12} md={3}
                        objeto={this.props.dadosNota}
                        bloqueado={this.somenteLeitura ? this.somenteLeitura : !!this.props.editar && this.props.isSSA}
                        dado={`Nf.QtdTotal`}
                        //alerta={ (this.props.salvo && !_.get(this.props.dadosNota, "Nf.QtdTotal")) ? "Campo obrigatório" : "" }
                        onChange={(event) => this.controller.setDadosNotaFiscal(`Nf.QtdTotal`, event.target.value)}
                    />}
                {this.controller.atualizaBagagem && this.controller.carregouNF &&
                    <FormInputCurrency titulo="Peso Total" sm={12} md={3} type="number"
                        bloqueado={this.somenteLeitura ? this.somenteLeitura : !!this.props.editar && this.props.isSSA}
                        objeto={this.props.dadosNota}
                        dado={`Nf.PesoTotal`}
                        formataMoeda={true}
                        separadorMilesimo=","
                        separadorDecimal="."
                        onChange={(event) => this.controller.setDadosNotaFiscal(`Nf.PesoTotal`, event.target.value)} />}
                {this.controller.atualizaBagagem &&
                    <FormSelect titulo="Transportadora" sm={12} md={3}
                        bloqueado={this.somenteLeitura ? this.somenteLeitura : !!this.props.editar && this.props.isSSA}
                        itens={this.props.transportadorasNotaFiscal}
                        objeto={this.props.dadosNota}
                        dado={"Nf.TranspId"}
                        itensValor="Id" itensLabel="Texto"
                        //alerta={(this.props.salvo && !_.get(this.controller.dadosNotaFiscal, "Nf.TranspId")) ? "Campo obrigatório" : ""}
                        onChange={(event) => this.controller.setDadosNotaFiscal(`Nf.TranspId`, event)} />
                }
                {(!this.props.importacaoXML || _.get(this.props.dadosNota, `Nf.DatEmissao`)) &&
                    <FormDatePicker md={3} sm={12} titulo="Emissão"
                        date={moment(_.get(this.props.dadosNota, `Nf.DatEmissao`))}
                        bloqueado={this.somenteLeitura ? this.somenteLeitura : !!this.props.editar && this.props.isSSA}
                        uniqueId="DatEmissao"
                        onChange={(event) => this.controller.setDadosNotaFiscal(`Nf.DatEmissao`, (event) ? moment(event, 'YYYY-MM-DD').format() : '')}
                    />}
                {(!this.props.importacaoXML || _.get(this.props.dadosNota, `Nf.DatSaidaEmissor`)) &&
                    <FormDatePicker md={3} sm={12} titulo="Saída"
                        date={moment(_.get(this.props.dadosNota, `Nf.DatSaidaEmissor`))}
                        bloqueado={this.somenteLeitura ? this.somenteLeitura : !!this.props.editar && this.props.isSSA}
                        uniqueId="DatSaidaEmissor"
                        onChange={(event) => this.controller.setDadosNotaFiscal(`Nf.DatSaidaEmissor`, (event) ? moment(event, 'YYYY-MM-DD').format() : '')}
                    />
                }
                {this.controller.atualizaBagagem && this.controller.carregouNF &&
                    <FormInputCurrency titulo="Valor Total" sm={12} md={3}
                        bloqueado={this.somenteLeitura ? this.somenteLeitura : !!this.props.editar && this.props.isSSA}
                        objeto={this.props.dadosNota}
                        dado={`Nf.ValTotal`}
                        formataMoeda={true}
                        separadorMilesimo=","
                        separadorDecimal="."
                        //alerta={ (this.props.salvo && !_.get(this.props.dadosNota, "Nf.ValTotal")) ? "Campo obrigatório" : "" }
                        onChange={(event) => this.controller.setDadosNotaFiscal(`Nf.ValTotal`, event.target.value)}
                    />}
                {this.controller.atualizaBagagem && this.controller.carregouNF &&
                    <FormInputCNPJCPF titulo="CNPJ do Emissor" sm={12} md={3}
                        bloqueado={this.somenteLeitura ? this.somenteLeitura : !!this.props.editar && this.props.isSSA}
                        objeto={this.props.dadosNota}
                        dado={`Nf.Cnpjs`}
                        limiteMaximo={18}
                        labelStatus={_.get(this.props.dadosNota, "Nf.Cnpjs") ? _.get(this.props.dadosNota, "Nf.CnpjEmissor_lblNaoExiste") : ""}
                        onChange={(event) => this.controller.setCNPJEmissor(`Nf.Cnpjs`, event.target.value.toUpperCase())}
                    />}
                {this.controller.atualizaBagagem && this.controller.atualizaCNPJEmiss &&
                    <FormInput titulo="Razão Social do Emissor" sm={12} md={3}
                        objeto={this.props.dadosNota}
                        bloqueado={this.somenteLeitura ? this.somenteLeitura : !!this.props.editar && this.props.isSSA}
                        dado={`Nf.RazaoSocialEmissor`}
                        onChange={(event) => this.controller.setDadosNotaFiscal(`Nf.RazaoSocialEmissor`, event)}
                    />}
                {!this.controller.atualizaCNPJEmiss &&
                    <FormInput titulo="Razão Social do Emissor" sm={12} md={3}
                        bloqueado={this.somenteLeitura ? this.somenteLeitura : false}
                    />}
            </Row>
            <Row className="mt-3">
                <Col>
                    <h2>Destinatário</h2>
                </Col>
            </Row>
            <Row className="area-form">
                {this.controller.atualizaBagagem && this.controller.carregouNF &&
                    <FormInputCNPJCPF titulo="CNPJ do Destinatário" sm={12} md={4}
                        bloqueado={this.somenteLeitura ? this.somenteLeitura : !!this.props.editar && this.props.isSSA}
                        objeto={this.props.dadosNota}
                        limiteMaximo={18}
                        dado={`Nf.CnpjDest`}
                        labelStatus={_.get(this.props.dadosNota, "Nf.CnpjDest") ? _.get(this.props.dadosNota, "Nf.CnpjDestinatario_lblNaoExiste") : ""}
                        onChange={(event) => this.controller.setCNPJDestinatarioSemPensar(`Nf.CnpjDest`, event.target.value)}
                    />}
                {this.controller.atualizaBagagem && this.controller.atualizaCNPJDest && <FormInput titulo="Razão Social" sm={12} md={4}
                    bloqueado={this.somenteLeitura ? this.somenteLeitura : !!this.props.editar && this.props.isSSA}
                    objeto={this.props.dadosNota}
                    dado={`Nf.RazaoSocialDest`}
                    limiteMaximo={80}
                    //alerta={ (this.props.salvo && !_.get(this.props.dadosNota, "Nf.RazaoSocialDest")) ? "Campo obrigatório" : "" }
                    onChange={(event) => this.controller.setDadosNotaFiscal(`Nf.RazaoSocialDest`, event.target.value)} />}
                {!this.controller.atualizaCNPJDest && <FormInput titulo="Razão Social" sm={12} md={4} />}
                {this.controller.atualizaBagagem &&
                    <FormInput titulo="Inscrição" sm={12} md={4}
                        bloqueado={this.somenteLeitura ? this.somenteLeitura : !!this.props.editar && this.props.isSSA}
                        objeto={this.props.dadosNota}
                        dado={`Nf.InscrEstadDest`}
                        onChange={(event) => this.controller.setDadosNotaFiscal(`Nf.InscrEstadDest`, event.target.value)} />
                }
                {this.controller.atualizaBagagem &&
                    <FormSelect titulo="País" sm={12} md={4}
                        bloqueado={this.somenteLeitura ? this.somenteLeitura : !!this.props.editar && this.props.isSSA}
                        itens={this.controller.paises}
                        objeto={this.props.dadosNota}
                        dado={"Nf.CdPaisDest"}
                        itensValor="Id" itensLabel="Texto"
                        //alerta={ (this.props.salvo && !_.get(this.props.dadosNota, "Nf.CdPaisDest")) ? "Campo obrigatório" : "" }
                        onChange={event => {
                            this.controller.setDadosNotaFiscal('Nf.CdPaisDest', event);
                            this.controller.setPais(event)
                        }} />
                }
                {this.controller.atualizaBagagem && (this.controller.paisSelecionado && _.get(this.props.dadosNota, "Nf.CdPaisDest"))
                    && <FormSelect titulo="UF" sm={12} md={4}
                        bloqueado={this.somenteLeitura ? this.somenteLeitura : !!this.props.editar && this.props.isSSA}
                        itens={this.controller.UFs}
                        objeto={this.props.dadosNota}
                        dado={"Nf.CdUnidadeFedDest"}
                        itensValor="Id" itensLabel="Texto"
                        onChange={(event) => {
                            this.controller.setDadosNotaFiscal(`Nf.CdUnidadeFedDest`, event);
                        }} />
                }
                {this.controller.atualizaBagagem && (this.controller.paisSelecionado && _.get(this.props.dadosNota, "Nf.CdPaisDest"))
                    && <FormInput titulo="Cidade" sm={12} md={4}
                        bloqueado={this.somenteLeitura ? this.somenteLeitura : !!this.props.editar && this.props.isSSA}
                        objeto={this.props.dadosNota}
                        dado={`Nf.NomCidadeDest`}
                        //alerta={ (this.props.salvo && !_.get(this.props.dadosNota, "Nf.NomCidadeDest")) ? "Campo obrigatório" : "" }
                        onChange={(event) => this.controller.setDadosNotaFiscal(`Nf.NomCidadeDest`, event.target.value)} />
                }
            </Row>
        </div>
    }

    listaContainers() {
        return <div>
            <Row>
                <Col>
                    <h2>Containers</h2>
                </Col>
            </Row>
            {
                this.appStore.isMobile()
                    ? <div>
                        {
                            this.controller.atualiza && this.controller.dadosNotaFiscal && this.controller.dadosNotaFiscal.ListaCntr.map((container, pos) => (
                                _.get(container, 'IndExcluido') !== 'S' && <div key={pos} className="card-branco area-form" >
                                    <CardNotaFiscalContainersLivre
                                        index={pos}
                                        container={container}
                                        controller={this.controller}
                                        dado={`${this.props.dadosNotaFiscal}.ListaCntr[${pos}]`}
                                        este={_.get(this.controller.dadosNotaFiscal, `ListaCntr[${pos}]`)}
                                        setDado={this.controller.setDadosNotaFiscal}
                                        remover={() => this.handleRemoverContainer(pos)}
                                        somenteLeitura={this.somenteLeitura} />
                                </div>
                            ))
                        }
                    </div>
                    : <div className="card-branco area-form">
                        <Row>
                            <Col sm={12} md={3}>
                                <Label>Container</Label>
                            </Col>
                            <Col sm={12} md={3}>
                                <Label>Booking</Label>
                            </Col>
                            <Col sm={12} md={3}>
                                <Label>Status</Label>
                            </Col>
                        </Row>
                        {
                            this.controller.atualiza && this.controller.dadosNotaFiscal.ListaCntr && this.controller.dadosNotaFiscal.ListaCntr.map((container, pos) => (
                                _.get(container, 'IndExcluido') !== 'S' && <CardNotaFiscalContainersLivre key={pos}
                                    index={pos}
                                    container={container}
                                    controller={this.controller}
                                    dado={`ListaCntr[${pos}]`}
                                    este={_.get(this.controller.dadosNotaFiscal, `ListaCntr[${pos}]`)}
                                    setDado={this.controller.setDadosNotaFiscal}
                                    remover={() => this.handleRemoverContainer(pos)}
                                    somenteLeitura={this.somenteLeitura} />
                            ))
                        }
                        <div className="area-btn-adicionar">
                            <div className="justify-content-end">
                                <Label className="btn-primary" onClick={() => { if (!this.somenteLeitura) this.controller.abrirInserirNovoNotaFiscalContainer(this.props.index) }}>Adicionar</Label>
                            </div>
                        </div>
                    </div>
            }
        </div>
    }

    listaNCMs() {
        return <div>
            <Row className="mt-3">
                <Col>
                    <h2>NCM</h2>
                </Col>
            </Row>
            {
                this.appStore.isMobile()
                    ? <div>
                        {this.controller.atualiza && this.props.dadosNota.ListaItem && this.props.dadosNota.ListaItem.map((ncm, pos) => (
                            _.get(ncm, 'IndExcluido') !== 'S' && <div key={pos} className="card-branco area-form" >
                                <CardNotaFiscalNCM
                                    index={pos}
                                    ncm={ncm}
                                    controller={this.controller}
                                    dado={`ListaItem[${pos}]`}
                                    este={_.get(this.props.dadosNota, `ListaItem[${pos}]`)}
                                    setDado={this.props.setDado}
                                    removeNCM={this.props.removerNCM}
                                    somenteLeitura={this.somenteLeitura} />
                            </div>
                        ))
                        }
                        <div className="area-btn-adicionar">
                            <div className="justify-content-end">
                                <Label className="btn-primary" onClick={() => { if (!this.somenteLeitura) this.controller.abrirInserirNovoNotaFiscalNCM(this.props.index) }}>Adicionar</Label>
                            </div>
                        </div>
                    </div>
                    : <div className="card-branco area-form">
                        <Row>
                            <Col sm={12} md={3}>
                                <Label>NCM</Label>
                            </Col>
                            <Col sm={12} md={2}>
                                <Label>Quantidade</Label>
                            </Col>
                            <Col sm={12} md={2}>
                                <Label>Valor Item</Label>
                            </Col>
                            <Col sm={12} md={2}>
                                <Label>Peso Item</Label>
                            </Col>
                            <Col sm={12} md={3}>
                                <Label>CFOP</Label>
                            </Col>
                        </Row>
                        {
                            this.controller.atualiza && this.props.dadosNota.ListaItem && this.props.dadosNota.ListaItem.map((ncm, pos) => (
                                _.get(ncm, 'IndExcluido') !== 'S' && <div key={pos} >
                                    <CardNotaFiscalNCM index={pos}
                                        ncm={ncm}
                                        controller={this.controller}
                                        dado={`ListaItem[${pos}]`}
                                        este={_.get(this.props.dadosNota, `ListaItem[${pos}]`)}
                                        setDado={this.props.setDado}
                                        removeNCM={this.props.removerNCM}
                                        somenteLeitura={this.somenteLeitura} />
                                </div>
                            ))
                        }
                        <div className="area-btn-adicionar">
                            <div className="justify-content-end">
                                <Label className="btn-primary" onClick={() => { if (!this.somenteLeitura) this.props.adicionarNovoNCM(this.props.index) }}>Adicionar</Label>
                            </div>
                        </div>
                    </div>
            }
        </div>
    }

    handleClickBitrem = (event) => {
        if (event) this.controller.setDadosNotaFiscal(`Nf.FlagBitrem`, { value: 'S' });
        else this.controller.setDadosNotaFiscal(`Nf.FlagBitrem`, { value: 'N' });
    };

    handleClickBagagem = (event) => {
        if (event && !this.somenteLeitura) {
            this.controller.setDadosNotaFiscal('Nf.FlagBagagem', { value: 'V' });
            this.controller.setDadosNotaFiscal(`Nf.SerieNotaTransp`, null);
            this.controller.setDadosNotaFiscal(`Nf.ChaveNfe`, null);
            this.controller.setDadosNotaFiscal(`Nf.TranspId`, null);
            this.controller.setDadosNotaFiscal(`Nf.NumNotaTransp`, null);
            this.controller.setDadosNotaFiscal(`Nf.QtdTotal`, null);
            this.controller.setDadosNotaFiscal(`Nf.PesoTotal`, null);
            this.controller.setDadosNotaFiscal(`Nf.ValTotal`, null);
            this.controller.setDadosNotaFiscal(`Nf.Cnpjs`, null);
            this.controller.setDadosNotaFiscal(`Nf.RazaoSocialEmissor`, null);
            this.controller.setDadosNotaFiscal(`Nf.CnpjDest`, null);
            this.controller.setDadosNotaFiscal(`Nf.RazaoSocialDest`, null);
            this.controller.setDadosNotaFiscal(`Nf.InscrEstadDest`, null);
            this.controller.setDadosNotaFiscal(`Nf.CdPaisDest`, null);
            this.controller.setDadosNotaFiscal(`Nf.CdUnidadeFedDest`, null);
            this.controller.setDadosNotaFiscal(`Nf.NomeCidadeDest`, null);

            this.controller.flagAtivo = true;
            this.props.setBagagemFlag(true);
            this.controller.atualizaBagagem = false;
            setTimeout(function () {
                this.controller.atualizaBagagem = true;
            }.bind(this), 1);
        }
        else {
            this.controller.setDadosNotaFiscal('Nf.FlagBagagem', { value: 'F' });
            this.controller.flagAtivo = false;
            this.props.setBagagemFlag(false);
        }

    };

    render() {

        return (
            <div className="card-expansivel">
                {this.props.loading ? <LoadingImage /> :
                    <div className="detalhes">
                        {this.listaNotaFiscal()}
                        {this.listaContainers()}
                        {this.listaNCMs()}
                    </div>
                }
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/agendamento/nota-fiscal-cadastrar/components/NotaFiscalForm.js